
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sugerencias-reclamos",
      function () {
        return require("private-next-pages/sugerencias-reclamos/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sugerencias-reclamos"])
      });
    }
  